<template>
  <div class="profile-card--mini">
    <div class="profile-card--mini__image" v-if="showAvatar">
      <router-link :to="{name:'UserProfile', params:{id: user.id}}">
        <user-avatar :user="user" />
      </router-link>
    </div>
    <div class="profile-card--mini__content" :class="{'u-hide-mobile':!showName}">
      <router-link :to="{name:'UserProfile', params:{id: user.id}}">{{user.name}}</router-link>
    </div>
  </div>
</template>

<script>
const UserAvatar = () => import("@/components/UserAvatar");
export default {
  name: "ProfileCardMini",
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: false
    }
  },

  components: {
    UserAvatar
  }
};
</script>

<style scoped lang="scss">
.profile-card--mini {
  display: inline-flex;
  align-items: center;

  &__image {
    width: 41px;
    max-width: 41px;
    border-radius: 100%;
    display: inline-block;
    overflow: hidden;
    margin-right: 20px;
    max-height: 41px;
    height: 41px;
    // flex: 1;
  }

  &__content {
    // flex: 1;

    a {
      text-decoration: none;
      font-weight: bold;
    }
  }
}
</style>